var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"modal-bg",on:{"click":_vm.hide}},[_c('div',{staticClass:"fadeInLeft animated modal",on:{"click":_vm.stopPropagation}},[_vm._t("default")],2)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }